<script>
  import { onMount } from "svelte";
  let sound;
  onMount(() => {
    sound = new Audio("dryer.mp3");
    sound.load();
  });
  let timer = setInterval(() => {
    if (!sound || !isRunning) {
      return;
    }
    if(sound.currentTime >=2.5){
      sound.currentTime = 0;
    }
  }, 100);

  let isRunning = false;
  const startDryer = () => {
    isRunning = true;
    sound.play();
  };
  const stopDryer = () => {
    isRunning = false;
    sound.pause();
    sound.currentTime = 0.0;
  };
</script>

<style>
  main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .hand-dryer {
    width: 320px;
  }

  area:hover {
    cursor: grab;
  }
</style>

<main>
  <h1>カーソルを当てると手が乾くぞ！</h1>
  <img
    class="hand-dryer"
    usemap="#sample"
    src="handdryer.png"
    alt="ハンドドライヤー" />
  <map name="sample">
    <area
      shape="rect"
      alt="四角形"
      coords="40,220,200,320"
      on:mouseover={startDryer}
      on:mouseleave={stopDryer} />
  </map>
</main>
